import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import { logout as logoutAction } from '$/store/login/actions';
import { useState } from 'react';
import { Navigate } from 'react-router-dom';

export interface ILogoutProps {
  logout: () => Promise<void>;
}

const Logout: React.FC<ILogoutProps> = props => {
  const { logout } = props;
  const [redirect, setRedirect] = useState(false);
  useEffect(() => {
    const doLogout = async () => {
      await logout();
      setRedirect(true);
    };
    doLogout();
  }, [logout]);

  return redirect ? <Navigate to="/" /> : null;
};
export default connect(undefined, {
  logout: logoutAction,
})(Logout);
